import { t } from "i18next";
import { useState } from "react";
import Button from "shared/UI/Buttons/Button";
import { Hideable } from "shared/UI/Hideable/Hideable";
import { StepsInputModal } from "./StepsInputModal";
import { trackAddHealthData, trackCancelHealthData } from "core/monitoring/Events";
import { TrackerType } from "core/state/Trackers/TrackerType";

export const StepsInput = () => {
  const [showAddDataModal, setShowAddDataModal] = useState(false);

  const handleAddData = () => {
    trackAddHealthData(TrackerType.Steps);
    setShowAddDataModal(true);
  };

  const handleCloseModal = () => {
    trackCancelHealthData(TrackerType.Steps);
    setShowAddDataModal(false);
  };
  return (
    <>
      <Button text={t("wellbeing.trackers.steps.addData.addButtonLabel")} onClick={handleAddData} />
      <Hideable hidden={!showAddDataModal}>
        <StepsInputModal onClose={handleCloseModal} />
      </Hideable>
    </>
  );
};
